import { render, staticRenderFns } from "./YpoCookiePolicy.vue?vue&type=template&id=4e4420e6&"
import script from "./YpoCookiePolicy.vue?vue&type=script&lang=js&"
export * from "./YpoCookiePolicy.vue?vue&type=script&lang=js&"
import style0 from "./YpoCookiePolicy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports